import type {
  CursorPagination,
  CursorPaginationParams,
  Customer,
  RentCarBookingStatus,
  Vehicle,
} from '.'

export enum CalendarViewMode {
  day = 'day',
  week = 'week',
  month = 'month',
}
export type TypeCalendarViewMode = CalendarViewMode

export type NewBookingStep = 'customer' | 'services' | 'schedule' | 'confirm'
export type SearchSelectionTab = 'customer' | 'vehicle'

export enum BookingViewMode {
  TIMELINE = 'timeline',
  KANBAN = 'kanban',
}
export type typeBookingViewMode = BookingViewMode

export interface Order {
  orderID: string
  orderNumber?: number
  driver?: Customer
  driverCar?: Vehicle
  submissionTime?: string
  submittedTime?: string
  pickupTime?: string
  pickedUpTime?: string
  updatedAt?: string
  orderStatus: OrderStatus
  total?: Array<number>
  currency?: Array<string>
  billed?: boolean
  services?: BookedService[]
  products?: BookedProducts[]
  orgID?: string
  storeID?: string
}

export interface BookingData extends CursorPagination {
  orders: Order[]
}

export interface OrderPackageDeal {
  orderPackageDealID: string
  packageVariantID: string
  orgID: string
  name: string
  price: number
  currency: string
  amount: number
  packageStatus: 'Active' | 'Inactive' | 'Archived'
}

export interface OrderDetail {
  orderID: string
  orderNumber?: number
  orgID?: string
  driverCarID?: string
  driverID?: string
  storeID?: string
  orderNotes?: string
  carSaleID?: string
  bookedBy?: string
  submissionTime?: string
  submittedTime?: string
  pickupTime?: string
  pickedUpTime?: string
  vatFree?: boolean
  orderStatus: OrderStatus
  currency?: string
  discount?: number
  createdAt?: string
  updatedAt?: string
  driver?: Customer
  cost?: number
  rentCarBooking?: BookedRentCar
  services?: BookedService[]
  products?: BookedProducts[]
  packageDeals?: OrderPackageDeal[]
}

export interface BookingListParams extends CursorPaginationParams {
  storeID: string
  orgID: string
  orderStatusSearch?: string
  carSaleID?: string
  to?: string
  from?: string
  billingStatus?: boolean
  includeServices?: boolean
  includeProducts?: boolean
}

export interface OrderSearchParams {
  orgID: string
  driverID?: string
  orderIDs?: string
}

export interface BookingUpdateParams {
  params: {
    orgID: string
    storeID: string
    orderID: string
  }
  data: Partial<BookingPayload>
}

export interface KanbanParams extends CursorPaginationParams {
  storeID: string
  date?: string
}

export interface BookingPayload {
  driverCarID: string
  driverID: string
  orderNotes: string
  carSaleID?: string
  bookedBy: string
  submissionTime: string
  submittedTime?: string
  pickupTime: string
  pickedUpTime?: string
  vatFree: boolean
  orderStatus: TypeOrderStatus
  currency: string
  discount: number
  services: BookedService[]
  products: BookedProducts[]
  rentCarBooking: BookedRentCar
  orgID?: string
  storeID?: string
}

export interface BookedProducts {
  productID?: string
  productDescription?: string
  amount?: string
  cost?: string
  currency?: string
  orderProductNotes?: string
  total?: number
}

export interface BookedRentCar {
  bookingStart?: string
  bookingEnd?: string
  bookedBy?: string
  bookingStatus?: RentCarBookingStatus
  submissionTime?: string
  rentCarRegNum?: string
  rentCarBookingID?: string
  orderID?: string
}

export interface BookedService {
  service: {
    serviceID: string
    serviceVariantID: string
    name: string
    amount: number
    cost: number
    currency: string
    vatFree: boolean
    orderNotes: string
    kanbanStatus: string
    total?: number
  }
  days: BookedServiceWorkSchedule[]
}

export interface BookedServiceWorkSchedule {
  employeeID: string
  workDay: string
  workDuration: number
  workDayID?: string
  orderID?: string
  storeID?: string
  createdAt?: string
  updatedAt?: string
}

export enum KanbanStatus {
  todo = 'TODO',
  inProgress = 'IN_PROGRESS',
  blcoked = 'BLOCKED',
  finished = 'FINISHED',
}
export type TypeKanbanStatus = KanbanStatus

export enum OrderStatus {
  preliminary = 'preliminary',
  created = 'created',
  inShop = 'inShop',
  startService = 'startService',
  pickedUp = 'pickedUp',
  finished = 'finished',
}
export type TypeOrderStatus = OrderStatus

export interface BookingPayloadResponse {
  order: Order
  cost: number
  rentCarBooking: BookedRentCar
  services: BookedService[]
  products: BookedProducts[]
}

export type BookingStep = 'customer' | 'schedule' | 'services' | 'rentCars' | 'confirm'
